import styled from 'styled-components';

export const Card = styled.div`
  background: var(--surface);
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 4px 6px var(--card-shadow);
  transition: all 0.3s ease;
  border: 1px solid var(--border);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 30px var(--card-shadow);
  }
`;

export const Button = styled.button`
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.2s ease;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  
  ${props => props.primary && `
    background: var(--primary);
    color: white;
    border: none;
    
    &:hover {
      background: var(--primary-dark);
      transform: translateY(-1px);
      box-shadow: 0 4px 12px var(--hover-shadow);
    }
  `}
  
  ${props => props.secondary && `
    background: var(--surface);
    color: var(--text-primary);
    border: 1px solid var(--border);
    
    &:hover {
      background: var(--surface-hover);
      transform: translateY(-1px);
    }
  `}
`;

export const Input = styled.input`
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: var(--surface);
  color: var(--text-primary);
  font-size: 14px;
  width: 100%;
  transition: all 0.2s ease;

  &:focus {
    border-color: var(--primary);
    box-shadow: 0 0 0 3px var(--hover-shadow);
  }

  &::placeholder {
    color: var(--text-tertiary);
  }
`;

export const Badge = styled.span`
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  background: var(--primary);
  color: white;
  
  ${props => props.success && `
    background: var(--success);
  `}
  
  ${props => props.warning && `
    background: var(--warning);
  `}
  
  ${props => props.error && `
    background: var(--error);
  `}
`;

export const Avatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--primary);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 16px;
`;

export const Tooltip = styled.div`
  position: relative;
  display: inline-block;

  &:hover span {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }

  span {
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%) translateY(-4px);
    padding: 8px 12px;
    background: var(--text-primary);
    color: var(--surface);
    font-size: 12px;
    border-radius: 4px;
    white-space: nowrap;
    opacity: 0;
    visibility: hidden;
    transition: all 0.2s ease;
  }
`;

export const LoadingSpinner = styled.div`
  width: 24px;
  height: 24px;
  border: 2px solid var(--border);
  border-top-color: var(--primary);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`; 